import * as React from 'react';
export const SSSvg = React.forwardRef(function SSSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#43458B',
      d: 'M.67 2.5A2 2 0 0 0 0 4v8a2 2 0 0 0 .67 1.5L8 8z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#333',
      d: 'M.67 2.5A2 2 0 0 1 2 2h12a2 2 0 0 1 2 2v1.58H4.77z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#E25950',
      d: 'M5.61 6.21H16v3.58H5.61L8 8z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#24B47E',
      d: 'M.67 13.5A2 2 0 0 0 2 14h12a2 2 0 0 0 2-2v-1.58H4.77z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F9FC',
      d: 'M4.77 5.58H15v.63H5.61zm.84 4.21H15v.63H4.77z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#EAEEF3',
      d: 'M15 5.58h1v.63h-1zm0 4.21h1v.63h-1z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FCD669',
      d: 'M2.33 6.16v1.17c0 .07-.04.13-.1.15l-1.12.36a.16.16 0 0 0 0 .31l1.11.36a.16.16 0 0 1 .12.16v1.17a.16.16 0 0 0 .29.1l.69-.95a.16.16 0 0 1 .18-.06l1.1.36a.16.16 0 0 0 .19-.25l-.63-.94a.16.16 0 0 1 0-.2l.63-.94a.16.16 0 0 0-.18-.25l-1.11.36a.16.16 0 0 1-.19-.06l-.68-.94a.16.16 0 0 0-.3.1Z',
    }),
  );
});
SSSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var SS = {
  category: 'flag',
  colorable: false,
  name: 'SS',
  svg: SSSvg,
};
